import React, { useState } from "react";
import { Box, Tabs, Tab, List, ListItem, ListItemText, Paper } from "@mui/material";
import { useTranslation } from "../../i18n";
import "./LearnTable.css";

const frameworks = {
    cypress: {
        title: "Cypress",
        topics: [
            { key: "introduccion", title: "Introducción a Cypress", video: "https://www.youtube.com/embed/Y-lvGx4Nebo" },
            { key: "primer-test", title: "Hacer Querying en Cypress", video: "https://youtu.be/jzgn377TgWA?si=eoR1jdjimp3l_PQd" },
            { key: "interaccion-ui", title: "Comandos de Traversal paso a paso", video: "https://youtu.be/H7meUk6yRJY?si=tEiBty0mxAHKlqob" },
            { key: "formularios-eventos", title: "Aprende las actions", video: "https://youtu.be/IhupF-KKGsg?si=1KjME2DSKbz1BsJI" },
            { key: "api-testing", title: "Control todal del navegador", video: "https://youtu.be/jMjQ3Oxk6rE?si=VBgPJfWgoRZnWYCa" },
            { key: "hooks-buenas-practicas", title: "Aserciones explicadas desde 0", video: "https://youtu.be/6XZxOH4WYCw?si=67kgfbZcgsBMvfcA" },
            { key: "ci-cd", title: "Ejecutar comandos y otras acciones", video: "https://youtu.be/rDZ54zFsqdk?si=we6APXK5Fsav3rZ2" }
        ]
    },
    cucumber: {
        title: "Cucumber",
        topics: [
            { key: "introduccion", title: "Introducción a Cucumber", video: "https://www.youtube.com/embed/tvQTni3PXAc?si=omr9juywsJW9j5VX" },
            { key: "que-es-cucumber", title: "Automatización API y Gherkin tables", video: "https://www.youtube.com/watch?v=tvQTni3PXAc" },
            { key: "primer-test", title: "Domina los hooks", video: "https://www.youtube.com/watch?v=P2Ikz5hJkZs" },
            { key: "step-definitions", title: "Definiendo Step Definitions en Cucumber", video: null },
            { key: "manejo-datos", title: "Manejo de datos en pruebas", video: null },
            { key: "cucumber-api", title: "Pruebas de API con Cucumber", video: null },
            { key: "ci-cd", title: "Ejecución de Cucumber en CI/CD", video: null }
        ]
    },
    playwright: {
        title: "Playwright",
        topics: [
            { key: "introduccion", title: "Introducción a Playwright", video: "https://www.youtube.com/watch?v=RDsJl_reY70&t" },
            { key: "setup", title: "Instalación y setup de Playwright", video: null },
            { key: "android-testing", title: "Automatización de pruebas en Android", video: null },
            { key: "ios-testing", title: "Automatización de pruebas en iOS", video: null },
            { key: "localizadores", title: "Gestión de localizadores en Playwright", video: null },
            { key: "frameworks-integration", title: "Integración otros frameworks", video: null },
            { key: "ci-cd", title: "Ejecución en CI/CD con Playwright", video: null }
        ]
    },
    postman: {
        title: "Postman",
        topics: [
            { key: "introduccion", title: "Introducción a Postman", video: "https://www.youtube.com/watch?v=LLJt1alI0vg&t" },
            { key: "setup", title: "Variables y entornos", video: "https://www.youtube.com/watch?v=oQSoibG-1II" },
            { key: "android-testing", title: "Automatización de pruebas en Android", video: null },
            { key: "ios-testing", title: "Automatización de pruebas en iOS", video: null },
            { key: "localizadores", title: "Gestión de localizadores en Postman", video: null },
            { key: "frameworks-integration", title: "Integración otros frameworks", video: null },
            { key: "ci-cd", title: "Ejecución en CI/CD con Postman", video: null }
        ]
    },
    appium: {
        title: "Appium",
        topics: [
            { key: "introduccion", title: "Introducción a Appium", video: null },
            { key: "setup", title: "Instalación y setup de Appium", video: null },
            { key: "android-testing", title: "Automatización de pruebas en Android", video: null },
            { key: "ios-testing", title: "Automatización de pruebas en iOS", video: null },
            { key: "localizadores", title: "Gestión de localizadores en Appium", video: null },
            { key: "frameworks-integration", title: "Integración otros frameworks", video: null },
            { key: "ci-cd", title: "Ejecución en CI/CD con Appium", video: null }
        ]
    }
};

const topicTitles = {
    en: {
        cypress: {
            introduccion: "Introduction to Cypress",
            "primer-test": "Querying in Cypress",
            "interaccion-ui": "Traversal commands step by step",
            "formularios-eventos": "Learn actions",
            "api-testing": "Full browser control",
            "hooks-buenas-practicas": "Assertions explained from scratch",
            "ci-cd": "Running commands and other actions"
        },
        cucumber: {
            introduccion: "Introduction to Cucumber",
            "que-es-cucumber": "API automation and Gherkin tables",
            "primer-test": "Master hooks",
            "step-definitions": "Defining Step Definitions in Cucumber",
            "manejo-datos": "Test data management",
            "cucumber-api": "API testing with Cucumber",
            "ci-cd": "Running Cucumber in CI/CD"
        },
        playwright: {
            introduccion: "Introduction to Playwright",
            setup: "Playwright installation and setup",
            "android-testing": "Test automation on Android",
            "ios-testing": "Test automation on iOS",
            localizadores: "Locator management in Playwright",
            "frameworks-integration": "Integration with other frameworks",
            "ci-cd": "Running Playwright in CI/CD"
        },
        postman: {
            introduccion: "Introduction to Postman",
            setup: "Variables and environments",
            "android-testing": "Test automation on Android",
            "ios-testing": "Test automation on iOS",
            localizadores: "Locator management in Postman",
            "frameworks-integration": "Integration with other frameworks",
            "ci-cd": "Running Postman in CI/CD"
        },
        appium: {
            introduccion: "Introduction to Appium",
            setup: "Appium installation and setup",
            "android-testing": "Test automation on Android",
            "ios-testing": "Test automation on iOS",
            localizadores: "Locator management in Appium",
            "frameworks-integration": "Integration with other frameworks",
            "ci-cd": "Running Appium in CI/CD"
        }
    },
    de: {
        cypress: {
            introduccion: "Einfuhrung in Cypress",
            "primer-test": "Querying in Cypress",
            "interaccion-ui": "Traversal-Befehle Schritt fur Schritt",
            "formularios-eventos": "Actions lernen",
            "api-testing": "Volle Browserkontrolle",
            "hooks-buenas-practicas": "Assertions von Grund auf erklart",
            "ci-cd": "Befehle und weitere Aktionen ausfuhren"
        },
        cucumber: {
            introduccion: "Einfuhrung in Cucumber",
            "que-es-cucumber": "API-Automatisierung und Gherkin-Tabellen",
            "primer-test": "Hooks meistern",
            "step-definitions": "Step Definitions in Cucumber definieren",
            "manejo-datos": "Testdaten verwalten",
            "cucumber-api": "API-Tests mit Cucumber",
            "ci-cd": "Cucumber in CI/CD ausfuhren"
        },
        playwright: {
            introduccion: "Einfuhrung in Playwright",
            setup: "Installation und Setup von Playwright",
            "android-testing": "Testautomatisierung auf Android",
            "ios-testing": "Testautomatisierung auf iOS",
            localizadores: "Locator-Verwaltung in Playwright",
            "frameworks-integration": "Integration mit anderen Frameworks",
            "ci-cd": "Playwright in CI/CD ausfuhren"
        },
        postman: {
            introduccion: "Einfuhrung in Postman",
            setup: "Variablen und Umgebungen",
            "android-testing": "Testautomatisierung auf Android",
            "ios-testing": "Testautomatisierung auf iOS",
            localizadores: "Locator-Verwaltung in Postman",
            "frameworks-integration": "Integration mit anderen Frameworks",
            "ci-cd": "Postman in CI/CD ausfuhren"
        },
        appium: {
            introduccion: "Einfuhrung in Appium",
            setup: "Installation und Setup von Appium",
            "android-testing": "Testautomatisierung auf Android",
            "ios-testing": "Testautomatisierung auf iOS",
            localizadores: "Locator-Verwaltung in Appium",
            "frameworks-integration": "Integration mit anderen Frameworks",
            "ci-cd": "Appium in CI/CD ausfuhren"
        }
    }
};

function toEmbedUrl(url) {
  try {
    const u = new URL(url);
    let id = null;
    let start = null;

    // youtu.be/<id>
    if (u.hostname.includes('youtu.be')) {
      id = u.pathname.slice(1);
      start = u.searchParams.get('t') || u.searchParams.get('start');
    }

    // youtube.com/watch?v=<id>
    if (!id && u.hostname.includes('youtube.com') && u.pathname === '/watch') {
      id = u.searchParams.get('v');
      start = u.searchParams.get('t') || u.searchParams.get('start');
    }

    // ya en /embed/<id>
    if (!id && u.pathname.startsWith('/embed/')) {
      id = u.pathname.split('/embed/')[1];
      start = u.searchParams.get('start') || u.searchParams.get('t');
    }

    if (!id) return null;

    // convertir t=1m25s o 85 -> segundos
    const toSeconds = (t) => {
      if (!t) return null;
      if (/^\d+$/.test(t)) return Number(t);
      const m = t.match(/(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?/);
      if (!m) return null;
      const [, h, mnt, s] = m.map(x => Number(x || 0));
      return h * 3600 + mnt * 60 + s;
    };

    const startSec = toSeconds(start);
    const params = new URLSearchParams({
      rel: '0',
      modestbranding: '1',
      autoplay: '1',   // para que inicie solo (mejor con mute)
      mute: '1',       // los navegadores suelen exigir mute para autoplay
    });
    if (startSec) params.set('start', String(startSec));

    // usa nocookie si prefieres
    return `https://www.youtube-nocookie.com/embed/${id}?${params.toString()}`;
  } catch {
    return null;
  }
}

const LearnTable = () => {
    const { language, t } = useTranslation();
    const [selectedFramework, setSelectedFramework] = useState("cypress");
    const [selectedTopic, setSelectedTopic] = useState(frameworks[selectedFramework].topics[0].key);
    const getTopicTitle = (frameworkKey, topic) => {
        return topicTitles[language]?.[frameworkKey]?.[topic.key] || topic.title;
    };

    const src = toEmbedUrl(
        frameworks[selectedFramework].topics.find(opt => opt.key === selectedTopic)?.video || ""
    );

    return (
        <Box className="learn-table-container">
            <Tabs
                value={selectedFramework}
                onChange={(event, newValue) => {
                    setSelectedFramework(newValue);
                    setSelectedTopic(frameworks[newValue].topics[0].key);
                }}
                centered
                indicatorColor="#7a857d"  // 🔹 Desactiva la línea azul
                className="tabs-container"
            >
                {Object.keys(frameworks).map((key) => (
                    <Tab key={key} label={frameworks[key].title} value={key} className="tab-item" />
                ))}
            </Tabs>

            <Paper className="table-content">
                <Box className="topics-list">
                    <List>
                        {frameworks[selectedFramework].topics.map((topic) => (
                            <ListItem
                                button
                                key={topic.key}
                                selected={selectedTopic === topic.key}
                                onClick={() => setSelectedTopic(topic.key)}
                                className={`topic-item ${selectedTopic === topic.key ? "active" : ""}`}
                            >
                                <ListItemText primary={getTopicTitle(selectedFramework, topic)} />
                            </ListItem>
                        ))}
                    </List>
                </Box>

                <Box className="video-container">
                    {src ? (
                        <iframe
                        className="video-frame"
                        src={src}
                        title={t("learn.videoTitle")}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                        />
                    ) : (
                        <p className="no-video-message">🎥 {t("learn.noVideo")}</p>
                    )}
                </Box>
            </Paper>
        </Box>
    );
};

export default LearnTable;
